import { render, staticRenderFns } from "./reporting.vue?vue&type=template&id=44d022f6&"
import script from "./reporting.vue?vue&type=script&lang=js&"
export * from "./reporting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports